import * as RouterStore from '@ngrx/router-store';
import { createFeatureSelector } from '@ngrx/store';
import * as Store from '@app/store';

export const selectRouter = createFeatureSelector<
  RouterStore.RouterReducerState<any>
>('routerState');

export const {
  selectCurrentRoute,
  selectQueryParam,
  selectQueryParams,
  selectRouteData,
  selectRouteParam,
  selectRouteParams,
  selectUrl,
} = RouterStore.getRouterSelectors(selectRouter);
